<template>
  <div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Vehicle Size</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                size="sm"
                variant="warning"
                v-if="showMain==false"
                @click="goToMain"
              >New Entry</b-button>

              <b-button
                size="sm"
                class="ml-2"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                @click="truckSize('Excel')"
                variant="outline-info"
                > {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>

            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div v-if="showMain==true">
              <b-card style="background:whiteSmoke">
                <b-row>
                  <b-col md="3">
                    <md-layout md-flex="100">
                      <label>Vehicle Size</label>
                      <b-form-input :formatter="capitalizeAll" id="vehicleSize" name="vehicleSize" v-model="vehicleSize"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!vehicleSize">{{vehicleSizeError}}</span>
                  </b-col>
                  <b-col md="3">
                    <md-layout md-flex="20" style="margin-top:35px">
                      <b-button variant="primary" @click="addVehicleSize" id="addButtonLoader">Add</b-button>
                      <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                    </md-layout>
                  </b-col>
                </b-row>
              </b-card>
            </div>

            <div class="box">
              <!-- /.box-header -->
              <div class="table-responsive tableMain mt-3">
                <table id="vehicleSizenew" class="table">
                  <thead>
                    <tr>
                      <th>Sr.no</th>

                      <th>Vehicle Size</th>
                      <th>Creation Date</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item1,index) in vehicleSizeMaster" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item1.vehicleSize}}</td>
                      <td>{{item1.loginTime | moment}}</td>
                      <td>
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          @click="deleteData(item1.vehicleSizeId)"
                        >
                          <md-icon>delete_sweep</md-icon>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>
            <!-- <md-layout md-gutter>
              <md-layout md-flex="50"></md-layout>
              <md-layout md-flex="25">
                <md-input-container>
                  <label>Upload File</label>
                  <md-file
                    name="excelUpload"
                    id="excelUpload"
                    v-model="excelUpload"
                    @selected="onFileChange()"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  ></md-file>
                </md-input-container>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-button
                  style="margin-top:18px"
                  class="md-raised md-primary md-button-color heght-1px"
                  @click="downloadExcel"
                  id
                >Download Excel</md-button>
              </md-layout>
            </md-layout>-->
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/vehicle/vehicleSize");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/vehicleSize/");
      if (globalPermissionStatus("vehicleMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("vehicleMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }

      this.truckSize("Normal");
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      showMain: false,
      deleteId: "",
      vehicleSize: "",
      vehicleSizeMaster: [{}],
      validate: true,
      vehicleSizeError: "",
      excelUpload: ""
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker
  },
  computed: {},
  methods: {
    goToMain() {
      this.showMain = true;
    },
    JqueryFun() {
      return $(function() {
        return $("#vehicleSizenew").DataTable();
      });
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;

      if (this.vehicleSize == "") {
        $("#vehicleSize").focus();
        this.vehicleSizeError = "Enter Vehicle Size";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addVehicleSize() {
      this.validateAddVehicleSizeForm();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let new_Size_Data = {
          vehicleSize: this.vehicleSize
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addVehicleSize.php`,
          data: JSON.stringify(new_Size_Data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            if (result.data.Id != "" && result.data.Id != undefined) {
              this.truckSize("Normal");
              this.vehicleSize = "";
              this.vehicleSizeError = "";
              this.$refs["addPop"].open();
              this.showMain = false;
            }
          })
          .catch(error => {});
      }
    },

    truckSize(type) {
      let type_Size = {
        truckSize: "truckSize",
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewVehicleSize.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.vehicleSizeMaster = data.truckSizeDetails;

            if (type == "Excel") {
              if (data.truckSizeDetails.length > 0) {
                this.vehicleSizeMaster = data.truckSizeDetails;
                this.totalRows = data.truckSizeDetails.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.truckSizeDetails.length > 0) {
                this.vehicleSizeMaster = data.truckSizeDetails;
                this.totalRows = data.truckSizeDetails.length;
                console.log("Vehicle Type Master List response=>", data);
              }
            }
            //  console.log("fsf",data.truckSizeDetails)
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    downloadExcel() {
      let excelName = {
        excelName: "VehicleSizeMaster",
        validExcel: "yes"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch(error => {});
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`vehicleSizeMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then(result => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.truckSize("Normal");
        })
        .catch(err => {
          throw err;
        });
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "vehiclesizemaster",
          tableId: "vehicleSizeId",
          tableIsActive: "isVehicleSizeActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              // this.JqueryFun();
              this.truckSize("Normal");
              // console.log(data);
            }
          })
          .catch(error => {});
      }
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.btn-outline-primary:hover .md-icon.md-theme-default.material-icons {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// vehicleSize.vue?e3e61112